import React from "react";
import { IoSearch } from "react-icons/io5";
import Divider from "../../components/Divider";
import PickInput from "../../components/PickInput";

const ShopFilters = () => {
  return (
    <div>
      <div className="filters-wrapper text-sm text-[#717171] px-4">
        <div className="w-10 h-12"></div>
        <div className="search p-3">
          <form action="">
            <label htmlFor="shop-search">
              <div className="flex border-2 border-[#e7e7e7] rounded-full overflow-hidden px-3 py-2 items-center">
                <div className="flex-auto">
                  <input
                    type="search"
                    name=""
                    id="shop-search"
                    className="outline-none w-full text-[13px]"
                    placeholder="Search Products..."
                  />
                </div>
                <div className="text-[#636363]">
                  <IoSearch />
                </div>
              </div>
            </label>
          </form>
        </div>
        <div className="items p-3">
          <div className="title uppercase font-medium text-[12px] text-black py-2">
            <h4>Items</h4>
          </div>
          <Divider />
          <div className="py-1">
            <ul>
              <li className="py-1 cursor-pointer transition-all duration-200 hover:text-black">
                <p className="flex justify-between">
                  <span className="cats">All</span>
                  <span className="count">1298</span>
                </p>
              </li>
              <li className="py-1 cursor-pointer transition-all duration-200 hover:text-black">
                <p className="flex justify-between capitalize">
                  <span className="cats">On Sale</span>
                  <span className="count">198</span>
                </p>
              </li>
              <li className="py-1 cursor-pointer transition-all duration-200 hover:text-black">
                <p className="flex justify-between">
                  <span className="cats">Sets of 2</span>
                  <span className="count">1298</span>
                </p>
              </li>
              <li className="py-1 cursor-pointer transition-all duration-200 hover:text-black">
                <p className="flex justify-between">
                  <span className="cats">Sets of 3</span>
                  <span className="count">1298</span>
                </p>
              </li>
              <li className="py-1 cursor-pointer transition-all duration-200 hover:text-black">
                <p className="flex justify-between">
                  <span className="cats">Scandinavian</span>
                  <span className="count">1298</span>
                </p>
              </li>
              <li className="py-1 cursor-pointer transition-all duration-200 hover:text-black">
                <p className="flex justify-between">
                  <span className="cats">Botanical</span>
                  <span className="count">1298</span>
                </p>
              </li>
              <li className="py-1 cursor-pointer transition-all duration-200 hover:text-black focus:bg-black">
                <p className="flex justify-between">
                  <span className="cats">Inspirational Quotes</span>
                  <span className="count">1298</span>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div className="items p-3">
          <div className="title uppercase font-medium text-[12px] text-black py-2">
            <h4>Special Offers</h4>
          </div>
          <Divider />
          <div className="py-1">
            <form action="">
              <ul>
                <li className="py-1 cursor-pointer transition-all duration-200 hover:text-black">
                  <PickInput id={"new"}>New</PickInput>
                </li>
                <li className="py-1 cursor-pointer transition-all duration-200 hover:text-black">
                  <PickInput id={"free-shipping"}>Free Shipping</PickInput>
                </li>
                <li className="py-1 cursor-pointer transition-all duration-200 hover:text-black">
                  <PickInput id={"on-sale"}>On Sale</PickInput>
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className="items p-3">
          <div className="title uppercase font-medium text-[12px] text-black py-2">
            <h4>Special Offers</h4>
          </div>
          <Divider />
          <div className="py-1">
            <form action="">
              <ul>
                <li className="py-1 cursor-pointer transition-all duration-200 hover:text-black">
                  <PickInput name={"price"} id={"price-1"} inputType={"radio"}>
                    Under $25
                  </PickInput>
                </li>
                <li className="py-1 cursor-pointer transition-all duration-200 hover:text-black">
                  <PickInput name={"price"} id={"price-2"} inputType={"radio"}>
                    $25 to $50
                  </PickInput>
                </li>
                <li className="py-1 cursor-pointer transition-all duration-200 hover:text-black">
                  <PickInput name={"price"} id={"price-3"} inputType={"radio"}>
                    $50 to $100
                  </PickInput>
                </li>
                <li className="py-1 cursor-pointer transition-all duration-200 hover:text-black">
                  <PickInput name={"price"} id={"price-4"} inputType={"radio"}>
                    $100 to $200
                  </PickInput>
                </li>
                <li className="py-1 cursor-pointer transition-all duration-200 hover:text-black">
                  <PickInput name={"price"} id={"price-5"} inputType={"radio"}>
                    $200 to Above
                  </PickInput>
                </li>
              </ul>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopFilters;
